<template>
  <section class="sec sec2" id="input-form">
  <div class="container">
    <article class="content text-center mb-50 ">
      <h1 class='font_0'>Calculate Cost of Funding a Pension</h1>
      <p style="font-size: 14px;">
        Use the inputs below to estimate the amount needed to fund a
        pensioner's lifetime income. More countries coming soon!
        <br class="visible-md visible-lg">
      </p>
    </article>
    <div class="row">
      <div class="col-xs-12 col-sm-11 col-md-10 mx-auto">
        <form class="formCont" v-on:submit.prevent="submitData">
          <p class="form-field form-field-country clearfix">
            <label for="country">Country</label>
            <span class="field">
              <jquery-selectmenu
                  :value='selectedCountry'
                  @input="updateSelectedCountry"
                  :options="countries"
                  name="country"
                  class="form-control jquerydropdown"
                  id="country"
                />
            </span>
          </p>
          <p class="form-field form-field-retirmentAge clearfix">
            <label for="retirmentAge">Retirement Age</label>
            <span class="field">
              <input
                type="number"
                v-model="agePaymentsStart"
                name="retirmentAge"
                id="retirmentAge"
                class="form-control" />
                <div class="error" v-if="!$v.agePaymentsStart.between">
                  Must be between {{$v.agePaymentsStart.$params.between.min - 1}} (age of purchase) and
                  {{$v.agePaymentsStart.$params.between.max}} (life expectancy).
                </div>
                <div class="error" v-if="!$v.agePaymentsStart.required">
                  You must enter a value here.
                </div>
            </span>
          </p>
          <p class="form-field form-field-retirmentAge clearfix">
            <label for="annuityPurchaseAge">Current age</label>
            <span class="field">
              <input
                type="number"
                v-model="ageAnnuityBought"
                name="annuityPurchaseAge"
                id="annuityPurchaseAge"
                class="form-control" />
                <div class="error" v-if="!$v.ageAnnuityBought.between">
                  Must be between {{$v.ageAnnuityBought.$params.between.min}} and
                  {{$v.ageAnnuityBought.$params.between.max}}
                </div>
                <div class="error" v-if="!$v.ageAnnuityBought.required">
                  You must enter a value here.
                </div>
            </span>
          </p>
          <ul class="form-field-radios list-inline col-md-10" style="padding-left: 0px;">
            <li class="form-field" style="padding-left: 0px;">
              <label class="custom-radio">
                <input v-model='gender' type="radio" name="gender" value="male"  />
                <span class="label-text">Male</span>
              </label>
            </li>
            <li  class="form-field">
              <label class="custom-radio">
                <input v-model='gender' type="radio" name="gender" value="female"  />
                <span class="label-text">Female</span>
              </label>
            </li>
          </ul>

          <div class="form-group">
            <div class="col-md-2">
              <button
              id="singlebutton"
              style="width: 100%"
              name="singlebutton"
              class="btn btn-primary btn-submit">SUBMIT</button>
            </div>
            <div class="error" v-if="submitStatus == 'ERROR'">
              <div class="col-md-2">
              There are errors in the above form.
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>

  </div>
  <section class="sec sec2">
    <Results v-if="result"/>
  </section>
  </section>
</template>

<script>
import annuities from '../js/annuityCalc.js'
import { mapGetters } from 'vuex'
import JquerySelectmenu from '../elements/jquery-selectmenu.vue'
import { required, between, minValue } from 'vuelidate/lib/validators'
import Results from './Results.vue'

export default {
  name: 'Inputs',
  components: {
    'jquery-selectmenu': JquerySelectmenu,
    'Results': Results
  },
  data: function () {
    return {
      submitStatus: null
    }
  },
  validations() {
    return {
      ageAnnuityBought: {
        required,
        between: between(22, 85)
      },
      agePaymentsStart: {
        required,
        between: between(parseInt(this.selectedCurrentAge) + 1, this.lifeExpectancy),
      },
    }
  },
  computed: {
    ...mapGetters([
      'result',
      'countries',
      'selectedCurrentAge',
      'selectedAgePaymentsStart',
      'selectedCountry',
      'selectedGender',
      'lifeExpectancy'
    ]),
    gender: {
      get() {
        return this.selectedGender;
      },
      set(value) {
        this.$store.commit("setSelectedGender", value);
      }
    },
    agePaymentsStart: {
      get() {
        return this.selectedAgePaymentsStart;
      },
      set(value) {
        this.$v.agePaymentsStart.$touch()
        this.$store.commit("setSelectedAgePaymentsStart", value);
        if (!this.$v.$invalid) {
          this.submitStatus = 'NO_ERRORS'
        }
      }
    },
    ageAnnuityBought: {
      get() {
        return this.selectedCurrentAge;
      },
      set(value) {
        this.$v.ageAnnuityBought.$touch()
        this.$store.commit("setSelectedCurrentAge", value);
        if (!this.$v.$invalid) {
          this.submitStatus = 'NO_ERRORS'
        }
      }
    },
    country: {
      get() {
        return this.selectedCountry;
      },
      set(value) {
        this.$store.commit('setSelectedCountry', value)
      }
    },
    agePaymentsStartOptions: function(){
      return [...Array(100).keys()]
    }
  },
  methods: {
    updateSelectedCountry: function(value) {
      this.$store.commit('setSelectedCountry', value)
    },
    submitData(){
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        annuities.calc({ ctx: this })
        this.submitStatus = 'OK'
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
